module.exports = __webpack_public_path__ + "static/media/reg9kz.8e032b72.pdf";